import { render, staticRenderFns } from "./IconLoader.vue?vue&type=template&id=1ff0c702&scoped=true&"
import script from "./IconLoader.vue?vue&type=script&lang=js&"
export * from "./IconLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff0c702",
  null
  
)

export default component.exports